export default __webpack_public_path__ + "static/media/close-icon-small-tip-jar.421e0e19.svg";